<div class="toggle-container border-light radius-xl">
    <button class="py-1 px-2 content-m border-none"  type="button" [class.active]="!value" (click)="setValue(false)">
        {{leftLabel}}
    </button>
    <button class="py-1 px-2 content-m border-none" type="button" [class.active]="value" (click)="setValue(true)">
        {{rightLabel}}
    </button>
</div>